
/* styles */
require("!!../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-369c3ae7&scoped=true!sass-loader?sourceMap!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./card-taxes.vue")

var Component = require("!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=script&index=0!./card-taxes.vue"),
  /* template */
  require("!!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-369c3ae7!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./card-taxes.vue"),
  /* scopeId */
  "data-v-369c3ae7",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/card-taxes.vue
// module id = 1876
// module chunks = 1